import { ReactNode } from "react";
import classNames from "classnames/bind";
import styles from "./Button.module.css";
import { ButtonLoader } from "../Loader";

const cx = classNames.bind(styles);

type ButtonType = "submit" | "button";
type ButtonLookType =
  | "primary"
  | "secondary"
  | "active"
  | "klasha-pink-bold"
  | "klasha-pink-light"
  | "cancel";

interface ButtonProps {
  onClick?: () => void;
  type: ButtonType;
  text: string | ReactNode;
  buttonStyle: ButtonLookType;
  disabled?: boolean;
  isButtonLoading?: boolean;
}
export const Button = ({
  type = "button",
  text,
  buttonStyle = "primary",
  onClick = () => {},
  disabled = false,
  isButtonLoading,
}: ButtonProps) => {
  return (
    <button
      disabled={disabled}
      type={type}
      className={cx({
        button: true,
        primary: buttonStyle === "primary",
        secondary: buttonStyle === "secondary",
        active: buttonStyle === "active",
        "klasha-pink-bold": buttonStyle === "klasha-pink-bold",
        "klasha-pink-light":
          buttonStyle === "klasha-pink-light" || isButtonLoading,

        cancel: buttonStyle === "cancel",
      })}
      onClick={onClick}
    >
      {isButtonLoading ? <ButtonLoader /> : text}
    </button>
  );
};
